import { foldMarketplaceProduct } from '../types/MarketplaceProduct';
export default product => foldMarketplaceProduct(product)(() => 'Jira', () => 'Confluence', () => 'Compass');